<template>
  <div class="scroll-tab-area">
    <div class="app-tab-wrap">
      <button
        type="button"
        class="tab"
        v-for="filter in filterList"
        :key="filter.value"
        :class="{ on: filter.value === activeValue }"
        @click="$emit('change', filter.value)"
      >
        {{ t(filter.label) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    filterList: readonly Record<string, string>[];
    activeValue: string | null;
  }>(),
  {
    filterList: () => [],
    activeValue: '',
  }
);

defineEmits(['change']);

const { t } = useI18n();
</script>

<style scoped lang="scss"></style>
